// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rcw-message {
  margin: 10px;
  display: flex;
  white-space: pre-wrap;
  word-wrap: break-word;
}

.rcw-message-client {
  flex-direction: row-reverse;
}

.rcw-timestamp {
  font-size: 10px;
  margin-top: 5px;
}

.rcw-client {
  display: flex;
  flex-direction: column;
  margin-left: auto;
}

.rcw-client .rcw-message-text {
  background-color: #a3eaf7;
  border-radius: 10px;
  max-width: 215px;
  padding: 15px;
  text-align: left;
  white-space: pre-wrap;
  word-wrap: break-word;
}

.rcw-client .rcw-timestamp {
  align-self: flex-end;
}

.rcw-response {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.rcw-response .rcw-message-text {
  background-color: #f4f7f9;
  border-radius: 10px;
  max-width: 215px;
  padding: 15px;
  text-align: left;
}

.rcw-message-text p {
  margin: 0;
}

.rcw-message-text img {
  width: 100%;
  object-fit: contain;
}

.rcw-avatar {
  width: 40px;
  height: 40px;
  border-radius: 100%;
  margin-right: 10px;
}

.rcw-avatar-client {
  margin: 0 0 0 10px;
}

.rcw-snippet {
  background-color: #f4f7f9;
  border-radius: 10px;
  max-width: 215px;
  padding: 15px;
  text-align: left;
}

.rcw-snippet-title {
  margin: 0;
}

.rcw-snippet-details {
  border-left: 2px solid #35e65d;
  margin-top: 5px;
  padding-left: 10px;
}

.rcw-link {
  font-size: 12px;
}

.quick-button {
  background: none;
  border-radius: 15px;
  border: 2px solid #35cce6;
  font-weight: 700;
  padding: 5px 10px;
  cursor: pointer;
  outline: 0;
}

.quick-button:active {
  background: #35cce6;
  color: #fff;
}

.rcw-conversation-container .rcw-header {
  background-color: #e63535 !important;
  border-radius: 10px 10px 0 0;
  color: #fff;
  display: flex;
  flex-direction: column;
  text-align: center;
  padding: 15px 0 25px;
}

.rcw-conversation-container .rcw-title {
  font-size: 24px;
  margin: 0;
  padding: 15px 0;
}

.rcw-conversation-container .rcw-close-button {
  display: none;
}

.rcw-conversation-container .avatar {
  width: 40px;
  height: 40px;
  border-radius: 100%;
  margin-right: 10px;
  vertical-align: middle;
}

.rcw-full-screen .rcw-header {
  border-radius: 0;
  flex-shrink: 0;
  position: relative;
}

.rcw-full-screen .rcw-title {
  padding: 0 0 15px;
}

.rcw-full-screen .rcw-close-button {
  background-color: #35cce6;
  border: 0;
  display: block;
  position: absolute;
  right: 10px;
  top: 20px;
  width: 40px;
}

.rcw-full-screen .rcw-close {
  width: 20px;
  height: 20px;
}

@media screen and (max-width: 800px) {
  .rcw-conversation-container .rcw-header {
    border-radius: 0;
    flex-shrink: 0;
    position: relative;
  }

  .rcw-conversation-container .rcw-title {
    padding: 0 0 15px;
  }

  .rcw-conversation-container .rcw-close-button {
    background-color: #35cce6;
    border: 0;
    display: block;
    position: absolute;
    right: 10px;
    top: 20px;
    width: 40px;
  }

  .rcw-conversation-container .rcw-close {
    width: 20px;
    height: 20px;
  }
}

.loader {
  margin: 10px;
  /* display: none */
}

.loader.active {
  display: flex;
}

.loader-container {
  background-color: #f4f7f9;
  border-radius: 10px;
  padding: 15px;
  max-width: 215px;
  text-align: left;
}

.loader-dots {
  display: inline-block;
  height: 4px;
  width: 4px;
  border-radius: 50%;
  background: grey;
  margin-right: 2px;
  animation: bounce 0.5s ease infinite alternate;
}

.loader-dots:first-child {
  animation-delay: 0.2s;
}

.loader-dots:nth-child(2) {
  animation-delay: 0.3s;
}

.loader-dots:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes bounce {
  0% {
    transform: translateY(0);
  }

  to {
    transform: translateY(5px);
  }
}

.rcw-messages-container {
  background-color: #fff;
  height: 50vh;
  max-height: 410px;
  overflow-y: scroll;
  padding-top: 10px;
  -webkit-overflow-scrolling: touch;
}

.rcw-full-screen .rcw-messages-container {
  height: 100%;
  max-height: none;
}

@media screen and (max-width: 800px) {
  .rcw-messages-container {
    height: 100%;
    max-height: none;
  }
}

.rcw-sender {
  align-items: flex-end;
  background-color: #f4f7f9;
  border-radius: 0 0 10px 10px;
  display: flex;
  height: max-content;
  max-height: 95px;
  min-height: 45px;
  overflow: hidden;
  padding: 10px;
  position: relative;
}

.rcw-sender.expand {
  height: 55px;
}

.rcw-new-message {
  background-color: #fff;
  border: 0;
  border-radius: 5px;
  padding: 10px 5px;
  resize: none;
  width: calc(100% - 75px);
}

.rcw-new-message:focus {
  outline: none;
}

.rcw-new-message.expand {
  height: 40px;
}

.rcw-input {
  display: block;
  height: 100%;
  line-height: 20px;
  max-height: 78px;
  overflow-y: auto;
  -webkit-user-select: text;
  user-select: text;
  white-space: pre-wrap;
  word-wrap: break-word;
}

.rcw-input.focus-visible,
.rcw-input:focus-visible {
  outline: none;
}

.rcw-input[placeholder]:empty:before {
  content: attr(placeholder);
  color: grey;
}

.rcw-picker-btn,
.rcw-send {
  background: #f4f7f9;
  border: 0;
  cursor: pointer;
}

.rcw-picker-btn .rcw-send-icon,
.rcw-send .rcw-send-icon {
  height: 25px;
}

.rcw-message-disable {
  background-color: #f4f7f9;
  cursor: not-allowed;
}

@media screen and (max-width: 800px) {
  .rcw-sender {
    border-radius: 0;
    flex-shrink: 0;
  }
}

.quick-buttons-container {
  background: #fff;
  overflow-x: auto;
  white-space: nowrap;
  padding: 10px;
}

.quick-buttons-container .quick-buttons {
  list-style: none;
  padding: 0;
  margin: 0;
  text-align: center;
}

.quick-buttons-container .quick-buttons .quick-list-button {
  display: inline-block;
  margin-right: 10px;
}

@media screen and (max-width: 800px) {
  .quick-buttons-container {
    padding-bottom: 15px;
  }
}

.emoji-mart,
.emoji-mart * {
  box-sizing: border-box;
  line-height: 1.15;
}

.emoji-mart {
  font-family:
    -apple-system,
    BlinkMacSystemFont,
    Helvetica Neue,
    sans-serif;
  font-size: 16px;
  display: inline-block;
  color: #222427;
  border: 1px solid #d9d9d9;
  border-radius: 5px;
  background: #fff;
}

.emoji-mart .emoji-mart-emoji {
  padding: 6px;
}

.emoji-mart-bar {
  border: 0 solid #d9d9d9;
}

.emoji-mart-bar:first-child {
  border-bottom-width: 1px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

.emoji-mart-bar:last-child {
  border-top-width: 1px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}

.emoji-mart-anchors {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0 6px;
  line-height: 0;
}

.emoji-mart-anchor {
  position: relative;
  display: block;
  flex: 1 1 auto;
  color: #858585;
  text-align: center;
  padding: 12px 4px;
  overflow: hidden;
  transition: color 0.1s ease-out;
  margin: 0;
  box-shadow: none;
  background: none;
  border: none;
}

.emoji-mart-anchor:focus {
  outline: 0;
}

.emoji-mart-anchor-selected,
.emoji-mart-anchor:focus,
.emoji-mart-anchor:hover {
  color: #464646;
}

.emoji-mart-anchor-selected .emoji-mart-anchor-bar {
  bottom: 0;
}

.emoji-mart-anchor-bar {
  position: absolute;
  bottom: -3px;
  left: 0;
  width: 100%;
  height: 3px;
  background-color: #464646;
}

.emoji-mart-anchors i {
  display: inline-block;
  width: 100%;
  max-width: 22px;
}

.emoji-mart-anchors img,
.emoji-mart-anchors svg {
  fill: currentColor;
  height: 18px;
  width: 18px;
}

.emoji-mart-scroll {
  overflow-y: scroll;
  overflow-x: hidden;
  height: 270px;
  padding: 0 6px 6px;
  will-change: transform;
}

.emoji-mart-search {
  margin-top: 6px;
  padding: 0 6px;
  position: relative;
}

.emoji-mart-search input {
  font-size: 16px;
  display: block;
  width: 100%;
  padding: 5px 25px 6px 10px;
  border-radius: 5px;
  border: 1px solid #d9d9d9;
  outline: 0;
}

.emoji-mart-search input,
.emoji-mart-search input::-webkit-search-cancel-button,
.emoji-mart-search input::-webkit-search-decoration,
.emoji-mart-search input::-webkit-search-results-button,
.emoji-mart-search input::-webkit-search-results-decoration {
  -webkit-appearance: none;
}

.emoji-mart-search-icon {
  position: absolute;
  top: 7px;
  right: 11px;
  z-index: 2;
  padding: 2px 5px 1px;
  border: none;
  background: none;
}

.emoji-mart-category .emoji-mart-emoji span {
  z-index: 1;
  position: relative;
  text-align: center;
  cursor: default;
}

.emoji-mart-category .emoji-mart-emoji:hover:before {
  z-index: 0;
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #f4f4f4;
  border-radius: 100%;
}

.emoji-mart-category-label {
  z-index: 2;
  position: relative;
  position: sticky;
  top: 0;
}

.emoji-mart-category-label span {
  display: block;
  width: 100%;
  font-weight: 500;
  padding: 5px 6px;
  background-color: #fff;
  background-color: hsla(0, 0%, 100%, 0.95);
}

.emoji-mart-category-list {
  margin: 0;
  padding: 0;
}

.emoji-mart-category-list li {
  list-style: none;
  margin: 0;
  padding: 0;
  display: inline-block;
}

.emoji-mart-emoji {
  position: relative;
  display: inline-block;
  font-size: 0;
  margin: 0;
  padding: 0;
  border: none;
  background: none;
  box-shadow: none;
}

.emoji-mart-emoji-native {
  font-family:
    Segoe UI Emoji,
    Segoe UI Symbol,
    Segoe UI,
    Apple Color Emoji,
    Twemoji Mozilla,
    Noto Color Emoji,
    Android Emoji;
}

.emoji-mart-no-results {
  font-size: 14px;
  text-align: center;
  padding-top: 70px;
  color: #858585;
}

.emoji-mart-no-results-img {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 50%;
}

.emoji-mart-no-results .emoji-mart-category-label {
  display: none;
}

.emoji-mart-no-results .emoji-mart-no-results-label {
  margin-top: 0.2em;
}

.emoji-mart-no-results .emoji-mart-emoji:hover:before {
  content: none;
}

.emoji-mart-preview {
  position: relative;
  height: 70px;
}

.emoji-mart-preview-data,
.emoji-mart-preview-emoji,
.emoji-mart-preview-skins {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.emoji-mart-preview-emoji {
  left: 12px;
}

.emoji-mart-preview-data {
  left: 68px;
  right: 12px;
  word-break: break-all;
}

.emoji-mart-preview-skins {
  right: 30px;
  text-align: right;
}

.emoji-mart-preview-skins.custom {
  right: 10px;
  text-align: right;
}

.emoji-mart-preview-name {
  font-size: 14px;
}

.emoji-mart-preview-shortname {
  font-size: 12px;
  color: #888;
}

.emoji-mart-preview-emoticon + .emoji-mart-preview-emoticon,
.emoji-mart-preview-shortname + .emoji-mart-preview-emoticon,
.emoji-mart-preview-shortname + .emoji-mart-preview-shortname {
  margin-left: 0.5em;
}

.emoji-mart-preview-emoticon {
  font-size: 11px;
  color: #bbb;
}

.emoji-mart-title span {
  display: inline-block;
  vertical-align: middle;
}

.emoji-mart-title .emoji-mart-emoji {
  padding: 0;
}

.emoji-mart-title-label {
  color: #999a9c;
  font-size: 26px;
  font-weight: 300;
}

.emoji-mart-skin-swatches {
  font-size: 0;
  padding: 2px 0;
  border: 1px solid #d9d9d9;
  border-radius: 12px;
  background-color: #fff;
}

.emoji-mart-skin-swatches.custom {
  font-size: 0;
  border: none;
  background-color: #fff;
}

.emoji-mart-skin-swatches.opened .emoji-mart-skin-swatch {
  width: 16px;
  padding: 0 2px;
}

.emoji-mart-skin-swatches.opened .emoji-mart-skin-swatch.selected:after {
  opacity: 0.75;
}

.emoji-mart-skin-swatch {
  display: inline-block;
  width: 0;
  vertical-align: middle;
  transition-property: width, padding;
  transition-duration: 0.125s;
  transition-timing-function: ease-out;
}

.emoji-mart-skin-swatch:first-child {
  transition-delay: 0s;
}

.emoji-mart-skin-swatch:nth-child(2) {
  transition-delay: 0.03s;
}

.emoji-mart-skin-swatch:nth-child(3) {
  transition-delay: 0.06s;
}

.emoji-mart-skin-swatch:nth-child(4) {
  transition-delay: 0.09s;
}

.emoji-mart-skin-swatch:nth-child(5) {
  transition-delay: 0.12s;
}

.emoji-mart-skin-swatch:nth-child(6) {
  transition-delay: 0.15s;
}

.emoji-mart-skin-swatch.selected {
  position: relative;
  width: 16px;
  padding: 0 2px;
}

.emoji-mart-skin-swatch.selected:after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 4px;
  height: 4px;
  margin: -2px 0 0 -2px;
  background-color: #fff;
  border-radius: 100%;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.2s ease-out;
}

.emoji-mart-skin-swatch.custom {
  display: inline-block;
  width: 0;
  height: 38px;
  overflow: hidden;
  vertical-align: middle;
  transition-property: width, height;
  transition-duration: 0.125s;
  transition-timing-function: ease-out;
  cursor: default;
}

.emoji-mart-skin-swatch.custom.selected {
  position: relative;
  width: 36px;
  height: 38px;
  padding: 0 2px 0 0;
}

.emoji-mart-skin-swatch.custom.selected:after {
  content: "";
  width: 0;
  height: 0;
}

.emoji-mart-skin-swatches.custom .emoji-mart-skin-swatch.custom:hover {
  background-color: #f4f4f4;
  border-radius: 10%;
}

.emoji-mart-skin-swatches.custom.opened .emoji-mart-skin-swatch.custom {
  width: 36px;
  height: 38px;
  padding: 0 2px 0 0;
}

.emoji-mart-skin-swatches.custom.opened
  .emoji-mart-skin-swatch.custom.selected:after {
  opacity: 0.75;
}

.emoji-mart-skin-text.opened {
  display: inline-block;
  vertical-align: middle;
  text-align: left;
  color: #888;
  font-size: 11px;
  padding: 5px 2px;
  width: 95px;
  height: 40px;
  border-radius: 10%;
  background-color: #fff;
}

.emoji-mart-skin {
  display: inline-block;
  width: 100%;
  padding-top: 100%;
  max-width: 12px;
  border-radius: 100%;
}

.emoji-mart-skin-tone-1 {
  background-color: #ffc93a;
}

.emoji-mart-skin-tone-2 {
  background-color: #fadcbc;
}

.emoji-mart-skin-tone-3 {
  background-color: #e0bb95;
}

.emoji-mart-skin-tone-4 {
  background-color: #bf8f68;
}

.emoji-mart-skin-tone-5 {
  background-color: #9b643d;
}

.emoji-mart-skin-tone-6 {
  background-color: #594539;
}

.emoji-mart-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

.emoji-mart-dark {
  color: #fff;
  background-color: #222;
}

.emoji-mart-dark,
.emoji-mart-dark .emoji-mart-bar {
  border-color: #555453;
}

.emoji-mart-dark .emoji-mart-search input {
  color: #fff;
  border-color: #555453;
  background-color: #2f2f2f;
}

.emoji-mart-dark .emoji-mart-search-icon svg {
  fill: #fff;
}

.emoji-mart-dark .emoji-mart-category .emoji-mart-emoji:hover:before {
  background-color: #444;
}

.emoji-mart-dark .emoji-mart-category-label span {
  background-color: #222;
  color: #fff;
}

.emoji-mart-dark .emoji-mart-skin-swatches {
  border-color: #555453;
  background-color: #222;
}

.emoji-mart-dark .emoji-mart-anchor-selected,
.emoji-mart-dark .emoji-mart-anchor:focus,
.emoji-mart-dark .emoji-mart-anchor:hover {
  color: #bfbfbf;
}

.rcw-conversation-container {
  border-radius: 10px;
  box-shadow: 0 2px 10px 1px #b5b5b5;
  min-width: 370px;
  max-width: 90vw;
  position: relative;
}

.rcw-conversation-container.active {
  opacity: 1;
  transform: translateY(0);
  transition:
    opacity 0.3s ease,
    transform 0.3s ease;
}

.rcw-conversation-container.hidden {
  z-index: 1 !important;
  pointer-events: none;
  opacity: 0;
  transform: translateY(10px);
  transition:
    opacity 0.3s ease,
    transform 0.3s ease;
}

.rcw-conversation-resizer {
  cursor: col-resize;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 5px;
}

.emoji-mart-preview {
  display: none;
}

.rcw-full-screen .rcw-conversation-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

@media screen and (max-width: 800px) {
  .rcw-conversation-container {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
}

.rcw-launcher .rcw-badge {
  position: fixed;
  top: -10px;
  right: -5px;
  background-color: red;
  color: #fff;
  width: 25px;
  height: 25px;
  text-align: center;
  line-height: 25px;
  border-radius: 50%;
}

.rcw-launcher {
  -webkit-animation-delay: 0;
  -webkit-animation-duration: 0.5s;
  -webkit-animation-name: slide-in;
  -webkit-animation-fill-mode: forwards;
  -moz-animation-delay: 0;
  -moz-animation-duration: 0.5s;
  -moz-animation-name: slide-in;
  -moz-animation-fill-mode: forwards;
  animation-delay: 0;
  animation-duration: 0.5s;
  animation-name: slide-in;
  animation-fill-mode: forwards;
  align-self: flex-end;
  background-color: #35cce6;
  border: 0;
  border-radius: 50%;
  box-shadow: 0 2px 10px 1px #b5b5b5;
  height: 60px;
  margin-top: 10px;
  cursor: pointer;
  width: 60px;
}

.rcw-launcher:focus {
  outline: none;
}

.rcw-open-launcher {
  -webkit-animation-delay: 0;
  -webkit-animation-duration: 0.5s;
  -webkit-animation-name: rotation-rl;
  -webkit-animation-fill-mode: forwards;
  -moz-animation-delay: 0;
  -moz-animation-duration: 0.5s;
  -moz-animation-name: rotation-rl;
  -moz-animation-fill-mode: forwards;
  animation-delay: 0;
  animation-duration: 0.5s;
  animation-name: rotation-rl;
  animation-fill-mode: forwards;
}

.rcw-close-launcher {
  width: 20px;
  -webkit-animation-delay: 0;
  -webkit-animation-duration: 0.5s;
  -webkit-animation-name: rotation-lr;
  -webkit-animation-fill-mode: forwards;
  -moz-animation-delay: 0;
  -moz-animation-duration: 0.5s;
  -moz-animation-name: rotation-lr;
  -moz-animation-fill-mode: forwards;
  animation-delay: 0;
  animation-duration: 0.5s;
  animation-name: rotation-lr;
  animation-fill-mode: forwards;
}

@media screen and (max-width: 800px) {
  .rcw-launcher {
    bottom: 0;
    margin: 20px;
    position: fixed;
    right: 0;
  }

  .rcw-hide-sm {
    display: none;
  }
}

.rcw-previewer-container {
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.75);
  overflow: hidden;
  position: fixed;
  z-index: 9999;
  left: 0;
  top: 0;
}

.rcw-previewer-container .rcw-previewer-image {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  transition: all 0.3s ease;
}

.rcw-previewer-container .rcw-previewer-tools {
  position: fixed;
  right: 16px;
  bottom: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.rcw-previewer-container .rcw-previewer-button {
  padding: 0;
  margin: 16px;
  box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.3);
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  background-color: #fff;
  border: none;
}

.rcw-previewer-container .rcw-previewer-close-button {
  position: absolute;
  right: 0;
  top: 0;
}

.rcw-previewer-container .rcw-previewer-veil {
  width: 100%;
  height: 100%;
  overflow: scroll;
  position: relative;
}

@keyframes rotation-lr {
  0% {
    transform: rotate(-90deg);
  }

  to {
    transform: rotate(0);
  }
}

@keyframes rotation-rl {
  0% {
    transform: rotate(90deg);
  }

  to {
    transform: rotate(0);
  }
}

@keyframes slide-in {
  0% {
    opacity: 0;
    transform: translateY(10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slide-out {
  0% {
    opacity: 1;
    transform: translateY(0);
  }

  to {
    opacity: 0;
    transform: translateY(10px);
  }
}

.rcw-widget-container {
  bottom: 0;
  display: flex;
  flex-direction: column;
  margin: 0 20px 20px 0;
  position: relative !important;
  right: 0;
  z-index: 9999;
  width: 100% !important;
}

.rcw-full-screen {
  height: 100vh;
  margin: 0;
  max-width: none;
  width: 100%;
}

@media screen and (max-width: 800px) {
  .rcw-widget-container {
    height: 100%;
    height: 100vh;
    margin: 0;
    max-width: none;
    width: 100%;
  }
}

.rcw-previewer .rcw-message-img {
  cursor: pointer;
}

.rcw-close-widget-container {
  height: max-content;
  width: max-content;
}

/********************Custome Chat**************************/
/********************Custom Chat**************************/
.chat-container {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 180px); /* adjust according to your header */
}

.messegeBox {
  flex: 1 1;
  overflow-y: auto;
}

.chatBottom {
  flex-shrink: 0;
  position: relative;
}

.editor-wrapper {
  overflow: hidden;
  max-height: 0;
  opacity: 0;
  transition:
    max-height 0.35s ease,
    opacity 0.25s ease;
}

.editor-wrapper.open {
  max-height: 180px; /* editor height */
  opacity: 1;
}

.msgheader {
  height: 70px;
}

/* .messegeBox {
  height: calc(100vh - 314px);
  overflow-y: auto;
} */

/* .chatBottom {
  height: 146px;
} */

.requestMsg {
  text-align: left;
  background: #7070701a;
  color: #707070;
  padding: 5px 15px;
  border-radius: 10px 15px 0px 10px;
  width: max-content;
  max-width: 60%;
  margin: auto;
  margin-right: 0;
  margin-bottom: 10px;
  -webkit-border-radius: 10px 15px 0px 10px;
  -moz-border-radius: 10px 15px 0px 10px;
  -ms-border-radius: 10px 15px 0px 10px;
  -o-border-radius: 10px 15px 0px 10px;
}

.responseMsg {
  background: #016fe91a;
  color: #707070;
  padding: 5px 15px;
  border-radius: 15px 10px 10px 0;
  width: max-content;
  max-width: 60%;
  margin-bottom: 10px;
  -webkit-border-radius: 15px 10px 10px 0;
  -moz-border-radius: 15px 10px 10px 0;
  -ms-border-radius: 15px 10px 10px 0;
  -o-border-radius: 15px 10px 10px 0;
}

.chatBottom div {
  width: 100%;
  margin-bottom: 0 !important;
}

.chatBottom input[type="text"] {
  border-radius: 20px;
  -webkit-border-radius: 20px;
  -moz-border-radius: 20px;
  -ms-border-radius: 20px;
  -o-border-radius: 20px;
  margin-bottom: 0;
}

.attachmentBox {
  background-color: #e8eaf5;
  /* width: 140px; */
  width: max-content;
  bottom: 33px;
  right: 0;
}

.mediaicon {
  border: 1px solid;
  border-radius: 50%;
  width: 35px;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 5px;
  cursor: pointer;
  margin: auto;
}

.mediaicon svg {
  font-size: 1rem;
}

.chatimg {
  width: 100px;
}

.contentBox .nav-btn-bgcolor {
  background-color: var(--purple);
  color: white;
}

/********************RTMP Live Video Chat**************************/
.rtmp-chat .chat-main {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
}

.rtmp-chat-header {
  height: 56px;
  background: #ffffff;
  border-bottom: 1px solid #e5e7eb;
  display: flex;
  align-items: center;
  padding: 0 20px;
  gap: 16px;
  flex-shrink: 0;
  overflow: hidden;
}

.rtmp-chat-header .live-badge {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  background: #fee2e2;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 600;
  color: #dc2626;
  animation: pulse 2s infinite;
}

.rtmp-chat-header-title {
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
  flex-shrink: 0;
}

.header-spacer {
  flex: 1 1;
  min-width: 16px;
}

/* Toggle group — three toggle pills in header */
.toggle-group {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}

.toggle-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  white-space: nowrap;
}

.toggle-item.public {
  background: #fffbeb;
  border-bottom: 3px solid #fde68a;
}

.toggle-item-label {
  font-size: 12px;
  font-weight: 500;
  color: #6b7280;
  white-space: nowrap;
  line-height: 1;
}

.toggle-item-label strong {
  font-weight: 700;
  color: #374151;
}

.toggle-item-label.on {
  color: #1f2937;
}

.toggle-item.broadcast-active .toggle-item-label {
  color: #7c3aed;
}

/* Toggle switch */
.toggle-track {
  width: 36px;
  height: 20px;
  border-radius: 10px;
  position: relative;
  transition: background 0.2s ease;
  cursor: pointer;
  flex-shrink: 0;
  border: none;
  padding: 0;
  display: block;
}

.toggle-track.on {
  background: #016fe9;
}

.toggle-track.off {
  background: #d1d5db;
}

.toggle-track.broadcast-on {
  background: #7c3aed;
}

.toggle-thumb {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #fff;
  position: absolute;
  top: 3px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  transition: left 0.22s cubic-bezier(0.4, 0, 0.2, 1);
  pointer-events: none;
}

.toggle-track.on .toggle-thumb,
.toggle-track.broadcast-on .toggle-thumb {
  left: 18px;
}

.toggle-track.off .toggle-thumb {
  left: 3px;
}

/* Legacy visibility-pill hidden */
.visibility-pill {
  display: none;
}

.btn-participants {
  display: none;
  align-items: center;
  gap: 6px;
  background: #f3f4f6;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 6px 12px;
  font-size: 13px;
  color: #374151;
  font-weight: 500;
}

.btn-participants.show {
  display: flex;
}

.message-container {
  flex: 1 1;
  display: flex;
  overflow: hidden;
}

/* --- Sidebar --- */
.rtmp-sidebar {
  width: 280px;
  min-width: 280px;
  background: #ffffff;
  border-right: 1px solid #e5e7eb;
  display: flex;
  flex-direction: column;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
}

.sidebar.closed {
  width: 0;
  min-width: 0;
}

.sidebar-header {
  padding: 20px 16px 12px;
  border-bottom: 1px solid #f3f4f6;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.sidebar-title {
  font-size: 15px;
  font-weight: 600;
  color: #1f2937;
}

.sidebar-subtitle {
  font-size: 12px;
  color: #6b7280;
  margin-top: 2px;
}

.sidebar-subtitle .count {
  color: #059669;
  font-weight: 600;
}

.btn-close-sidebar {
  color: #9ca3af;
  padding: 4px;
  border-radius: 6px;
  display: flex;
}

.btn-close-sidebar:hover {
  color: #6b7280;
}

/* Search */
.sidebar-search {
  padding: 12px 12px 8px;
}

.search-box {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 8px 12px;
}

.search-box input {
  border: none;
  background: transparent;
  outline: none;
  font-size: 13px;
  color: #374151;
  width: 100%;
}

.student-list {
  flex: 1 1;
  overflow-y: auto;
  padding: 4px 8px;
}

.student-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  width: 100%;
  border-radius: 8px;
  text-align: left;
  transition: background 0.15s;
}

.student-item:hover {
  background: #f9fafb;
}

.student-item.selected {
  background: #eff6ff;
}

.avatar {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  flex-shrink: 0;
  background: linear-gradient(135deg, #e0e7ff, #c7d2fe);
  color: #4338ca;
}

.avatar.active-avatar {
  background: linear-gradient(135deg, #016fe9, #4f9cf7);
  color: #ffffff;
}

.avatar.small {
  width: 28px;
  height: 28px;
  font-size: 10px;
  font-weight: 700;
}

.student-name {
  font-size: 13px;
  font-weight: 500;
  color: #1f2937;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1 1;
  min-width: 0;
}

.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.status-dot.active {
  background: #059669;
}

.status-dot.idle {
  background: #d1d5db;
}

/* --- Chat Area --- */
.chat-area {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
}

/* Warning banner */
.warning-banner {
  background: #fffbeb;
  border-bottom: 1px solid #fde68a;
  padding: 8px 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12.5px;
  color: #92400e;
  font-weight: 500;
  animation: fadeUp 0.25s ease;
}

.warning-banner.hidden-state {
  display: none;
}

/* Messages container */
.messages {
  flex: 1 1;
  overflow-y: auto;
  padding: 16px 20px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-height: calc(100vh - 56px - 140px);
}

/* Message row */
.msg-row {
  display: flex;
  padding: 3px 0;
}

.msg-row.admin {
  justify-content: flex-end;
}

.msg-row.student {
  justify-content: flex-start;
}

.msg-col {
  max-width: 70%;
  display: flex;
  flex-direction: column;
}

.msg-row.admin .msg-col {
  align-items: flex-end;
}

.msg-row.student .msg-col {
  align-items: flex-start;
}

.msg-sender {
  font-size: 11px;
  font-weight: 600;
  color: #6b7280;
  margin-bottom: 3px;
  padding-left: 4px;
}

.msg-inner {
  display: flex;
  align-items: center;
  gap: 6px;
}

.msg-row.admin .msg-inner {
  flex-direction: row-reverse;
}

.msg-bubble {
  padding: 12px 14px;
  font-size: 13.5px;
  line-height: 1.5;
}

.msg-row.student .msg-bubble {
  background: #f3f4f6;
  color: #1f2937;
  border-radius: 16px 16px 16px 4px;
}

.msg-row.admin .msg-bubble {
  background: #016fe9;
  color: #fff;
  border-radius: 16px 16px 4px 16px;
}

/* Visibility tag under admin msgs */
.msg-visibility {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 4px;
  font-size: 11px;
}

.msg-visibility.vis {
  color: #059669;
}

.msg-visibility.hid {
  color: #9ca3af;
}

.msg-time {
  font-size: 10px;
  color: #9ca3af;
  margin-top: 2px;
}

/* Hover actions on student messages */
.msg-actions {
  display: none;
  gap: 2px;
  position: relative;
}

.msg-row.student:hover .msg-actions {
  display: flex;
}

.btn-msg-action {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #9ca3af;
  transition: all 0.15s;
}

.btn-msg-action:hover {
  border-color: #016fe9;
  color: #016fe9;
}

/* Action dropdown */
.action-dropdown {
  position: absolute;
  left: 32px;
  top: 0;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  z-index: 10;
  overflow: hidden;
  min-width: 140;
  display: none;
}

.action-dropdown.open {
  display: block;
}

.action-dropdown button {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 14px;
  width: 100%;
  font-size: 12.5px;
}

.action-dropdown .delete-btn {
  color: #dc2626;
}

.action-dropdown .delete-btn:hover {
  background: #fef2f2;
}

.action-dropdown .mute-btn {
  color: #d97706;
}

.action-dropdown .mute-btn:hover {
  background: #fffbeb;
}

/* New messages pill */
.new-msg-pill {
  position: absolute;
  bottom: 80px;
  left: 50%;
  transform: translateX(-50%);
  background: #016fe9;
  color: #fff;
  border-radius: 20px;
  padding: 6px 160px;
  font-size: 12px;
  font-weight: 500;
  box-shadow: 0 4px 12px rgba(1, 111, 233, 0.25);
  display: none;
  align-items: center;
  gap: 4px;
  z-index: 5;
  animation: fadeUp 0.2s ease;
}

.new-msg-pill.show {
  display: flex;
}

/* --- Compose Area --- */
.compose-area {
  border-top: 1px solid #e5e7eb;
  background: #ffffff;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Message input box */
.compose-input-area {
  padding: 12px 20px 16px;
  display: block;
}

.compose-visibility {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 12px;
  font-size: 14px;
  font-weight: 500;
  padding: 6px 14px;
  border-radius: 6px;
}

.compose-visibility.vis {
  color: #059669;
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
}

.compose-visibility.hid {
  color: #d97706;
  background: #fffbeb;
  border: 1px solid #fde68a;
}

.compose-row {
  display: flex;
  gap: 12px;
  align-items: center;
}

.compose-row .message {
  flex: 1 1;
  padding: 30px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  font-size: 14px;
  outline: none;
  line-height: 1.5;
  max-height: 120px;
  color: #1f2937;
  background: #f9fafb;
  transition:
    border 0.15s,
    background 0.15s;
}

.compose-row .message:focus {
  border-color: #016fe9;
  background: #ffffff;
}

.compose-input-area .btn-send {
  height: 48px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 16px;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.15s;
  flex-shrink: 0;
}

.compose-input-area .btn-send.active {
  background: #016fe9;
  color: #fff;
  box-shadow: 0 2px 8px rgba(1, 111, 233, 0.25);
}

.compose-input-area .btn-send.active:hover {
  background: #0157b8;
  box-shadow: 0 4px 12px rgba(1, 111, 233, 0.25);
}

.compose-input-area .btn-send.disabled {
  background: #e5e7eb;
  color: #9ca3af;
  cursor: not-allowed;
}

/* Toast */
.toast {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 9999;
  color: #fff;
  padding: 12px 16px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  display: none;
  align-items: center;
  gap: 12px;
  max-width: 340px;
  animation: toastIn 0.3s ease;
}

.toast.show {
  display: flex;
}

.toast.success {
  background: #059669;
}

.toast.warning {
  background: #d97706;
}

/* ════ RESPONSIVE ════ */
@media (max-width: 768px) {
  .sidebar {
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    z-index: 100;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  .sidebar.closed {
    width: 0;
    min-width: 0;
  }

  .btn-participants {
    display: flex;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Screen/TeacherPanel/chat.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;EAEX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,4BAA4B;EAC5B,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,gBAAgB;IAChB,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;IACzB,SAAS;IACT,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EAEjB,8CAA8C;AAChD;;AAEA;EAEE,qBAAqB;AACvB;;AAEA;EAEE,qBAAqB;AACvB;;AAEA;EAEE,qBAAqB;AACvB;;AAYA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE;IACE,YAAY;IACZ,gBAAgB;EAClB;AACF;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,4BAA4B;EAC5B,aAAa;EAGb,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EAGzB,iBAAiB;EACjB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,WAAW;AACb;;AAEA;;EAEE,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE;IACE,gBAAgB;IAChB,cAAc;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;;EAEE,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE;;;;cAIY;EACZ,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;EAC/B,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,WAAW;EACX,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,WAAW;EACX,0BAA0B;EAC1B,kBAAkB;EAClB,yBAAyB;EACzB,UAAU;AACZ;;AAEA;;;;;EAKE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,UAAU;EACV,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAElB,gBAAgB;EAChB,MAAM;AACR;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,SAAS;EACT,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;;;;;;;iBAOe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;;;EAGE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;;;EAGE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,QAAQ;EACR,sBAAsB;EACtB,mCAAmC;EACnC,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,UAAU;EACV,iCAAiC;AACnC;;AAEA;EACE,qBAAqB;EACrB,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,kCAAkC;EAClC,2BAA2B;EAC3B,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,wBAAwB;EACxB;;uBAEqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,UAAU;EACV,2BAA2B;EAC3B;;uBAEqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;EACd;AACF;;AAEA;EACE,eAAe;EACf,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,gCAAgC;EAChC,gCAAgC;EAChC,qCAAqC;EACrC,uBAAuB;EACvB,6BAA6B;EAC7B,6BAA6B;EAC7B,kCAAkC;EAClC,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;EACxB,6BAA6B;EAC7B,oBAAoB;EACpB,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,kCAAkC;EAClC,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,gCAAgC;EAChC,mCAAmC;EACnC,qCAAqC;EACrC,uBAAuB;EACvB,6BAA6B;EAC7B,gCAAgC;EAChC,kCAAkC;EAClC,kBAAkB;EAClB,wBAAwB;EACxB,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,gCAAgC;EAChC,mCAAmC;EACnC,qCAAqC;EACrC,uBAAuB;EACvB,6BAA6B;EAC7B,gCAAgC;EAChC,kCAAkC;EAClC,kBAAkB;EAClB,wBAAwB;EACxB,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE;IACE,SAAS;IACT,YAAY;IACZ,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,OAAO;EACP,MAAM;AACR;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;AACR;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAYA;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAYA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAcA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAcA;EACE;IACE,UAAU;IACV,wBAAwB;EAC1B;;EAEA;IACE,UAAU;IACV,2BAA2B;EAC7B;AACF;;AAEA;EACE,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,6BAA6B;EAC7B,QAAQ;EACR,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;IACb,SAAS;IACT,eAAe;IACf,WAAW;EACb;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EAGE,mBAAmB;EAGnB,kBAAkB;AACpB;;AAEA,2DAA2D;AAC3D,0DAA0D;AAC1D;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B,EAAE,oCAAoC;AACnE;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,UAAU;EACV;;sBAEoB;AACtB;;AAEA;EACE,iBAAiB,EAAE,kBAAkB;EACrC,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;;;GAGG;;AAEH;;GAEG;;AAEH;EACE,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,iBAAiB;EACjB,iCAAiC;EACjC,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,yCAAyC;EACzC,sCAAsC;EACtC,qCAAqC;EACrC,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,uCAAuC;EACvC,oCAAoC;EACpC,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,YAAY;AACd;;AAEA,mEAAmE;AACnE;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,eAAe;AACjB;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,cAAc;EACd,YAAY;EACZ,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,QAAQ;EACR,wCAAwC;EACxC,mDAAmD;EACnD,oBAAoB;AACtB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;;AAEA,kCAAkC;AAClC;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,iDAAiD;EACjD,gBAAgB;AAClB;;AAEA;EACE,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,cAAc;EACd,WAAW;AACb;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qDAAqD;EACrD,cAAc;AAChB;;AAEA;EACE,qDAAqD;EACrD,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,SAAO;EACP,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;EACnB,gCAAgC;EAChC,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA,uBAAuB;AACvB;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,sCAAsC;AACxC;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,iCAAiC;AACnC;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;EACzC,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,8CAA8C;EAC9C,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA,yBAAyB;AACzB;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA,sBAAsB;AACtB;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB;;oBAEkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE;IACE,eAAe;IACf,OAAO;IACP,MAAM;IACN,SAAS;IACT,YAAY;IACZ,yCAAyC;EAC3C;;EAEA;IACE,QAAQ;IACR,YAAY;EACd;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".rcw-message {\n  margin: 10px;\n  display: flex;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n}\n\n.rcw-message-client {\n  flex-direction: row-reverse;\n}\n\n.rcw-timestamp {\n  font-size: 10px;\n  margin-top: 5px;\n}\n\n.rcw-client {\n  display: flex;\n  flex-direction: column;\n  margin-left: auto;\n}\n\n.rcw-client .rcw-message-text {\n  background-color: #a3eaf7;\n  border-radius: 10px;\n  max-width: 215px;\n  padding: 15px;\n  text-align: left;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n}\n\n.rcw-client .rcw-timestamp {\n  align-self: flex-end;\n}\n\n.rcw-response {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.rcw-response .rcw-message-text {\n  background-color: #f4f7f9;\n  border-radius: 10px;\n  max-width: 215px;\n  padding: 15px;\n  text-align: left;\n}\n\n.rcw-message-text p {\n  margin: 0;\n}\n\n.rcw-message-text img {\n  width: 100%;\n  -o-object-fit: contain;\n  object-fit: contain;\n}\n\n.rcw-avatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 100%;\n  margin-right: 10px;\n}\n\n.rcw-avatar-client {\n  margin: 0 0 0 10px;\n}\n\n.rcw-snippet {\n  background-color: #f4f7f9;\n  border-radius: 10px;\n  max-width: 215px;\n  padding: 15px;\n  text-align: left;\n}\n\n.rcw-snippet-title {\n  margin: 0;\n}\n\n.rcw-snippet-details {\n  border-left: 2px solid #35e65d;\n  margin-top: 5px;\n  padding-left: 10px;\n}\n\n.rcw-link {\n  font-size: 12px;\n}\n\n.quick-button {\n  background: none;\n  border-radius: 15px;\n  border: 2px solid #35cce6;\n  font-weight: 700;\n  padding: 5px 10px;\n  cursor: pointer;\n  outline: 0;\n}\n\n.quick-button:active {\n  background: #35cce6;\n  color: #fff;\n}\n\n.rcw-conversation-container .rcw-header {\n  background-color: #e63535 !important;\n  border-radius: 10px 10px 0 0;\n  color: #fff;\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n  padding: 15px 0 25px;\n}\n\n.rcw-conversation-container .rcw-title {\n  font-size: 24px;\n  margin: 0;\n  padding: 15px 0;\n}\n\n.rcw-conversation-container .rcw-close-button {\n  display: none;\n}\n\n.rcw-conversation-container .avatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 100%;\n  margin-right: 10px;\n  vertical-align: middle;\n}\n\n.rcw-full-screen .rcw-header {\n  border-radius: 0;\n  flex-shrink: 0;\n  position: relative;\n}\n\n.rcw-full-screen .rcw-title {\n  padding: 0 0 15px;\n}\n\n.rcw-full-screen .rcw-close-button {\n  background-color: #35cce6;\n  border: 0;\n  display: block;\n  position: absolute;\n  right: 10px;\n  top: 20px;\n  width: 40px;\n}\n\n.rcw-full-screen .rcw-close {\n  width: 20px;\n  height: 20px;\n}\n\n@media screen and (max-width: 800px) {\n  .rcw-conversation-container .rcw-header {\n    border-radius: 0;\n    flex-shrink: 0;\n    position: relative;\n  }\n\n  .rcw-conversation-container .rcw-title {\n    padding: 0 0 15px;\n  }\n\n  .rcw-conversation-container .rcw-close-button {\n    background-color: #35cce6;\n    border: 0;\n    display: block;\n    position: absolute;\n    right: 10px;\n    top: 20px;\n    width: 40px;\n  }\n\n  .rcw-conversation-container .rcw-close {\n    width: 20px;\n    height: 20px;\n  }\n}\n\n.loader {\n  margin: 10px;\n  /* display: none */\n}\n\n.loader.active {\n  display: flex;\n}\n\n.loader-container {\n  background-color: #f4f7f9;\n  border-radius: 10px;\n  padding: 15px;\n  max-width: 215px;\n  text-align: left;\n}\n\n.loader-dots {\n  display: inline-block;\n  height: 4px;\n  width: 4px;\n  border-radius: 50%;\n  background: grey;\n  margin-right: 2px;\n  -webkit-animation: bounce 0.5s ease infinite alternate;\n  animation: bounce 0.5s ease infinite alternate;\n}\n\n.loader-dots:first-child {\n  -webkit-animation-delay: 0.2s;\n  animation-delay: 0.2s;\n}\n\n.loader-dots:nth-child(2) {\n  -webkit-animation-delay: 0.3s;\n  animation-delay: 0.3s;\n}\n\n.loader-dots:nth-child(3) {\n  -webkit-animation-delay: 0.4s;\n  animation-delay: 0.4s;\n}\n\n@-webkit-keyframes bounce {\n  0% {\n    transform: translateY(0);\n  }\n\n  to {\n    transform: translateY(5px);\n  }\n}\n\n@keyframes bounce {\n  0% {\n    transform: translateY(0);\n  }\n\n  to {\n    transform: translateY(5px);\n  }\n}\n\n.rcw-messages-container {\n  background-color: #fff;\n  height: 50vh;\n  max-height: 410px;\n  overflow-y: scroll;\n  padding-top: 10px;\n  -webkit-overflow-scrolling: touch;\n}\n\n.rcw-full-screen .rcw-messages-container {\n  height: 100%;\n  max-height: none;\n}\n\n@media screen and (max-width: 800px) {\n  .rcw-messages-container {\n    height: 100%;\n    max-height: none;\n  }\n}\n\n.rcw-sender {\n  align-items: flex-end;\n  background-color: #f4f7f9;\n  border-radius: 0 0 10px 10px;\n  display: flex;\n  height: -webkit-max-content;\n  height: -moz-max-content;\n  height: max-content;\n  max-height: 95px;\n  min-height: 45px;\n  overflow: hidden;\n  padding: 10px;\n  position: relative;\n}\n\n.rcw-sender.expand {\n  height: 55px;\n}\n\n.rcw-new-message {\n  background-color: #fff;\n  border: 0;\n  border-radius: 5px;\n  padding: 10px 5px;\n  resize: none;\n  width: calc(100% - 75px);\n}\n\n.rcw-new-message:focus {\n  outline: none;\n}\n\n.rcw-new-message.expand {\n  height: 40px;\n}\n\n.rcw-input {\n  display: block;\n  height: 100%;\n  line-height: 20px;\n  max-height: 78px;\n  overflow-y: auto;\n  -webkit-user-select: text;\n  -moz-user-select: text;\n  -ms-user-select: text;\n  user-select: text;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n}\n\n.rcw-input.focus-visible,\n.rcw-input:focus-visible {\n  outline: none;\n}\n\n.rcw-input[placeholder]:empty:before {\n  content: attr(placeholder);\n  color: grey;\n}\n\n.rcw-picker-btn,\n.rcw-send {\n  background: #f4f7f9;\n  border: 0;\n  cursor: pointer;\n}\n\n.rcw-picker-btn .rcw-send-icon,\n.rcw-send .rcw-send-icon {\n  height: 25px;\n}\n\n.rcw-message-disable {\n  background-color: #f4f7f9;\n  cursor: not-allowed;\n}\n\n@media screen and (max-width: 800px) {\n  .rcw-sender {\n    border-radius: 0;\n    flex-shrink: 0;\n  }\n}\n\n.quick-buttons-container {\n  background: #fff;\n  overflow-x: auto;\n  white-space: nowrap;\n  padding: 10px;\n}\n\n.quick-buttons-container .quick-buttons {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  text-align: center;\n}\n\n.quick-buttons-container .quick-buttons .quick-list-button {\n  display: inline-block;\n  margin-right: 10px;\n}\n\n@media screen and (max-width: 800px) {\n  .quick-buttons-container {\n    padding-bottom: 15px;\n  }\n}\n\n.emoji-mart,\n.emoji-mart * {\n  box-sizing: border-box;\n  line-height: 1.15;\n}\n\n.emoji-mart {\n  font-family:\n    -apple-system,\n    BlinkMacSystemFont,\n    Helvetica Neue,\n    sans-serif;\n  font-size: 16px;\n  display: inline-block;\n  color: #222427;\n  border: 1px solid #d9d9d9;\n  border-radius: 5px;\n  background: #fff;\n}\n\n.emoji-mart .emoji-mart-emoji {\n  padding: 6px;\n}\n\n.emoji-mart-bar {\n  border: 0 solid #d9d9d9;\n}\n\n.emoji-mart-bar:first-child {\n  border-bottom-width: 1px;\n  border-top-left-radius: 5px;\n  border-top-right-radius: 5px;\n}\n\n.emoji-mart-bar:last-child {\n  border-top-width: 1px;\n  border-bottom-left-radius: 5px;\n  border-bottom-right-radius: 5px;\n}\n\n.emoji-mart-anchors {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  padding: 0 6px;\n  line-height: 0;\n}\n\n.emoji-mart-anchor {\n  position: relative;\n  display: block;\n  flex: 1 1 auto;\n  color: #858585;\n  text-align: center;\n  padding: 12px 4px;\n  overflow: hidden;\n  transition: color 0.1s ease-out;\n  margin: 0;\n  box-shadow: none;\n  background: none;\n  border: none;\n}\n\n.emoji-mart-anchor:focus {\n  outline: 0;\n}\n\n.emoji-mart-anchor-selected,\n.emoji-mart-anchor:focus,\n.emoji-mart-anchor:hover {\n  color: #464646;\n}\n\n.emoji-mart-anchor-selected .emoji-mart-anchor-bar {\n  bottom: 0;\n}\n\n.emoji-mart-anchor-bar {\n  position: absolute;\n  bottom: -3px;\n  left: 0;\n  width: 100%;\n  height: 3px;\n  background-color: #464646;\n}\n\n.emoji-mart-anchors i {\n  display: inline-block;\n  width: 100%;\n  max-width: 22px;\n}\n\n.emoji-mart-anchors img,\n.emoji-mart-anchors svg {\n  fill: currentColor;\n  height: 18px;\n  width: 18px;\n}\n\n.emoji-mart-scroll {\n  overflow-y: scroll;\n  overflow-x: hidden;\n  height: 270px;\n  padding: 0 6px 6px;\n  will-change: transform;\n}\n\n.emoji-mart-search {\n  margin-top: 6px;\n  padding: 0 6px;\n  position: relative;\n}\n\n.emoji-mart-search input {\n  font-size: 16px;\n  display: block;\n  width: 100%;\n  padding: 5px 25px 6px 10px;\n  border-radius: 5px;\n  border: 1px solid #d9d9d9;\n  outline: 0;\n}\n\n.emoji-mart-search input,\n.emoji-mart-search input::-webkit-search-cancel-button,\n.emoji-mart-search input::-webkit-search-decoration,\n.emoji-mart-search input::-webkit-search-results-button,\n.emoji-mart-search input::-webkit-search-results-decoration {\n  -webkit-appearance: none;\n}\n\n.emoji-mart-search-icon {\n  position: absolute;\n  top: 7px;\n  right: 11px;\n  z-index: 2;\n  padding: 2px 5px 1px;\n  border: none;\n  background: none;\n}\n\n.emoji-mart-category .emoji-mart-emoji span {\n  z-index: 1;\n  position: relative;\n  text-align: center;\n  cursor: default;\n}\n\n.emoji-mart-category .emoji-mart-emoji:hover:before {\n  z-index: 0;\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: #f4f4f4;\n  border-radius: 100%;\n}\n\n.emoji-mart-category-label {\n  z-index: 2;\n  position: relative;\n  position: -webkit-sticky;\n  position: sticky;\n  top: 0;\n}\n\n.emoji-mart-category-label span {\n  display: block;\n  width: 100%;\n  font-weight: 500;\n  padding: 5px 6px;\n  background-color: #fff;\n  background-color: hsla(0, 0%, 100%, 0.95);\n}\n\n.emoji-mart-category-list {\n  margin: 0;\n  padding: 0;\n}\n\n.emoji-mart-category-list li {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: inline-block;\n}\n\n.emoji-mart-emoji {\n  position: relative;\n  display: inline-block;\n  font-size: 0;\n  margin: 0;\n  padding: 0;\n  border: none;\n  background: none;\n  box-shadow: none;\n}\n\n.emoji-mart-emoji-native {\n  font-family:\n    Segoe UI Emoji,\n    Segoe UI Symbol,\n    Segoe UI,\n    Apple Color Emoji,\n    Twemoji Mozilla,\n    Noto Color Emoji,\n    Android Emoji;\n}\n\n.emoji-mart-no-results {\n  font-size: 14px;\n  text-align: center;\n  padding-top: 70px;\n  color: #858585;\n}\n\n.emoji-mart-no-results-img {\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n  width: 50%;\n}\n\n.emoji-mart-no-results .emoji-mart-category-label {\n  display: none;\n}\n\n.emoji-mart-no-results .emoji-mart-no-results-label {\n  margin-top: 0.2em;\n}\n\n.emoji-mart-no-results .emoji-mart-emoji:hover:before {\n  content: none;\n}\n\n.emoji-mart-preview {\n  position: relative;\n  height: 70px;\n}\n\n.emoji-mart-preview-data,\n.emoji-mart-preview-emoji,\n.emoji-mart-preview-skins {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.emoji-mart-preview-emoji {\n  left: 12px;\n}\n\n.emoji-mart-preview-data {\n  left: 68px;\n  right: 12px;\n  word-break: break-all;\n}\n\n.emoji-mart-preview-skins {\n  right: 30px;\n  text-align: right;\n}\n\n.emoji-mart-preview-skins.custom {\n  right: 10px;\n  text-align: right;\n}\n\n.emoji-mart-preview-name {\n  font-size: 14px;\n}\n\n.emoji-mart-preview-shortname {\n  font-size: 12px;\n  color: #888;\n}\n\n.emoji-mart-preview-emoticon + .emoji-mart-preview-emoticon,\n.emoji-mart-preview-shortname + .emoji-mart-preview-emoticon,\n.emoji-mart-preview-shortname + .emoji-mart-preview-shortname {\n  margin-left: 0.5em;\n}\n\n.emoji-mart-preview-emoticon {\n  font-size: 11px;\n  color: #bbb;\n}\n\n.emoji-mart-title span {\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.emoji-mart-title .emoji-mart-emoji {\n  padding: 0;\n}\n\n.emoji-mart-title-label {\n  color: #999a9c;\n  font-size: 26px;\n  font-weight: 300;\n}\n\n.emoji-mart-skin-swatches {\n  font-size: 0;\n  padding: 2px 0;\n  border: 1px solid #d9d9d9;\n  border-radius: 12px;\n  background-color: #fff;\n}\n\n.emoji-mart-skin-swatches.custom {\n  font-size: 0;\n  border: none;\n  background-color: #fff;\n}\n\n.emoji-mart-skin-swatches.opened .emoji-mart-skin-swatch {\n  width: 16px;\n  padding: 0 2px;\n}\n\n.emoji-mart-skin-swatches.opened .emoji-mart-skin-swatch.selected:after {\n  opacity: 0.75;\n}\n\n.emoji-mart-skin-swatch {\n  display: inline-block;\n  width: 0;\n  vertical-align: middle;\n  transition-property: width, padding;\n  transition-duration: 0.125s;\n  transition-timing-function: ease-out;\n}\n\n.emoji-mart-skin-swatch:first-child {\n  transition-delay: 0s;\n}\n\n.emoji-mart-skin-swatch:nth-child(2) {\n  transition-delay: 0.03s;\n}\n\n.emoji-mart-skin-swatch:nth-child(3) {\n  transition-delay: 0.06s;\n}\n\n.emoji-mart-skin-swatch:nth-child(4) {\n  transition-delay: 0.09s;\n}\n\n.emoji-mart-skin-swatch:nth-child(5) {\n  transition-delay: 0.12s;\n}\n\n.emoji-mart-skin-swatch:nth-child(6) {\n  transition-delay: 0.15s;\n}\n\n.emoji-mart-skin-swatch.selected {\n  position: relative;\n  width: 16px;\n  padding: 0 2px;\n}\n\n.emoji-mart-skin-swatch.selected:after {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 4px;\n  height: 4px;\n  margin: -2px 0 0 -2px;\n  background-color: #fff;\n  border-radius: 100%;\n  pointer-events: none;\n  opacity: 0;\n  transition: opacity 0.2s ease-out;\n}\n\n.emoji-mart-skin-swatch.custom {\n  display: inline-block;\n  width: 0;\n  height: 38px;\n  overflow: hidden;\n  vertical-align: middle;\n  transition-property: width, height;\n  transition-duration: 0.125s;\n  transition-timing-function: ease-out;\n  cursor: default;\n}\n\n.emoji-mart-skin-swatch.custom.selected {\n  position: relative;\n  width: 36px;\n  height: 38px;\n  padding: 0 2px 0 0;\n}\n\n.emoji-mart-skin-swatch.custom.selected:after {\n  content: \"\";\n  width: 0;\n  height: 0;\n}\n\n.emoji-mart-skin-swatches.custom .emoji-mart-skin-swatch.custom:hover {\n  background-color: #f4f4f4;\n  border-radius: 10%;\n}\n\n.emoji-mart-skin-swatches.custom.opened .emoji-mart-skin-swatch.custom {\n  width: 36px;\n  height: 38px;\n  padding: 0 2px 0 0;\n}\n\n.emoji-mart-skin-swatches.custom.opened\n  .emoji-mart-skin-swatch.custom.selected:after {\n  opacity: 0.75;\n}\n\n.emoji-mart-skin-text.opened {\n  display: inline-block;\n  vertical-align: middle;\n  text-align: left;\n  color: #888;\n  font-size: 11px;\n  padding: 5px 2px;\n  width: 95px;\n  height: 40px;\n  border-radius: 10%;\n  background-color: #fff;\n}\n\n.emoji-mart-skin {\n  display: inline-block;\n  width: 100%;\n  padding-top: 100%;\n  max-width: 12px;\n  border-radius: 100%;\n}\n\n.emoji-mart-skin-tone-1 {\n  background-color: #ffc93a;\n}\n\n.emoji-mart-skin-tone-2 {\n  background-color: #fadcbc;\n}\n\n.emoji-mart-skin-tone-3 {\n  background-color: #e0bb95;\n}\n\n.emoji-mart-skin-tone-4 {\n  background-color: #bf8f68;\n}\n\n.emoji-mart-skin-tone-5 {\n  background-color: #9b643d;\n}\n\n.emoji-mart-skin-tone-6 {\n  background-color: #594539;\n}\n\n.emoji-mart-sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n}\n\n.emoji-mart-dark {\n  color: #fff;\n  background-color: #222;\n}\n\n.emoji-mart-dark,\n.emoji-mart-dark .emoji-mart-bar {\n  border-color: #555453;\n}\n\n.emoji-mart-dark .emoji-mart-search input {\n  color: #fff;\n  border-color: #555453;\n  background-color: #2f2f2f;\n}\n\n.emoji-mart-dark .emoji-mart-search-icon svg {\n  fill: #fff;\n}\n\n.emoji-mart-dark .emoji-mart-category .emoji-mart-emoji:hover:before {\n  background-color: #444;\n}\n\n.emoji-mart-dark .emoji-mart-category-label span {\n  background-color: #222;\n  color: #fff;\n}\n\n.emoji-mart-dark .emoji-mart-skin-swatches {\n  border-color: #555453;\n  background-color: #222;\n}\n\n.emoji-mart-dark .emoji-mart-anchor-selected,\n.emoji-mart-dark .emoji-mart-anchor:focus,\n.emoji-mart-dark .emoji-mart-anchor:hover {\n  color: #bfbfbf;\n}\n\n.rcw-conversation-container {\n  border-radius: 10px;\n  box-shadow: 0 2px 10px 1px #b5b5b5;\n  min-width: 370px;\n  max-width: 90vw;\n  position: relative;\n}\n\n.rcw-conversation-container.active {\n  opacity: 1;\n  transform: translateY(0);\n  transition:\n    opacity 0.3s ease,\n    transform 0.3s ease;\n}\n\n.rcw-conversation-container.hidden {\n  z-index: 1 !important;\n  pointer-events: none;\n  opacity: 0;\n  transform: translateY(10px);\n  transition:\n    opacity 0.3s ease,\n    transform 0.3s ease;\n}\n\n.rcw-conversation-resizer {\n  cursor: col-resize;\n  height: 100%;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 5px;\n}\n\n.emoji-mart-preview {\n  display: none;\n}\n\n.rcw-full-screen .rcw-conversation-container {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n@media screen and (max-width: 800px) {\n  .rcw-conversation-container {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n  }\n}\n\n.rcw-launcher .rcw-badge {\n  position: fixed;\n  top: -10px;\n  right: -5px;\n  background-color: red;\n  color: #fff;\n  width: 25px;\n  height: 25px;\n  text-align: center;\n  line-height: 25px;\n  border-radius: 50%;\n}\n\n.rcw-launcher {\n  -webkit-animation-delay: 0;\n  -webkit-animation-duration: 0.5s;\n  -webkit-animation-name: slide-in;\n  -webkit-animation-fill-mode: forwards;\n  -moz-animation-delay: 0;\n  -moz-animation-duration: 0.5s;\n  -moz-animation-name: slide-in;\n  -moz-animation-fill-mode: forwards;\n  animation-delay: 0;\n  animation-duration: 0.5s;\n  animation-name: slide-in;\n  animation-fill-mode: forwards;\n  align-self: flex-end;\n  background-color: #35cce6;\n  border: 0;\n  border-radius: 50%;\n  box-shadow: 0 2px 10px 1px #b5b5b5;\n  height: 60px;\n  margin-top: 10px;\n  cursor: pointer;\n  width: 60px;\n}\n\n.rcw-launcher:focus {\n  outline: none;\n}\n\n.rcw-open-launcher {\n  -webkit-animation-delay: 0;\n  -webkit-animation-duration: 0.5s;\n  -webkit-animation-name: rotation-rl;\n  -webkit-animation-fill-mode: forwards;\n  -moz-animation-delay: 0;\n  -moz-animation-duration: 0.5s;\n  -moz-animation-name: rotation-rl;\n  -moz-animation-fill-mode: forwards;\n  animation-delay: 0;\n  animation-duration: 0.5s;\n  animation-name: rotation-rl;\n  animation-fill-mode: forwards;\n}\n\n.rcw-close-launcher {\n  width: 20px;\n  -webkit-animation-delay: 0;\n  -webkit-animation-duration: 0.5s;\n  -webkit-animation-name: rotation-lr;\n  -webkit-animation-fill-mode: forwards;\n  -moz-animation-delay: 0;\n  -moz-animation-duration: 0.5s;\n  -moz-animation-name: rotation-lr;\n  -moz-animation-fill-mode: forwards;\n  animation-delay: 0;\n  animation-duration: 0.5s;\n  animation-name: rotation-lr;\n  animation-fill-mode: forwards;\n}\n\n@media screen and (max-width: 800px) {\n  .rcw-launcher {\n    bottom: 0;\n    margin: 20px;\n    position: fixed;\n    right: 0;\n  }\n\n  .rcw-hide-sm {\n    display: none;\n  }\n}\n\n.rcw-previewer-container {\n  width: 100vw;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.75);\n  overflow: hidden;\n  position: fixed;\n  z-index: 9999;\n  left: 0;\n  top: 0;\n}\n\n.rcw-previewer-container .rcw-previewer-image {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  margin: auto;\n  transition: all 0.3s ease;\n}\n\n.rcw-previewer-container .rcw-previewer-tools {\n  position: fixed;\n  right: 16px;\n  bottom: 16px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.rcw-previewer-container .rcw-previewer-button {\n  padding: 0;\n  margin: 16px;\n  box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.3);\n  border-radius: 50%;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  outline: none;\n  background-color: #fff;\n  border: none;\n}\n\n.rcw-previewer-container .rcw-previewer-close-button {\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.rcw-previewer-container .rcw-previewer-veil {\n  width: 100%;\n  height: 100%;\n  overflow: scroll;\n  position: relative;\n}\n\n@-webkit-keyframes rotation-lr {\n  0% {\n    transform: rotate(-90deg);\n  }\n\n  to {\n    transform: rotate(0);\n  }\n}\n\n@keyframes rotation-lr {\n  0% {\n    transform: rotate(-90deg);\n  }\n\n  to {\n    transform: rotate(0);\n  }\n}\n\n@-webkit-keyframes rotation-rl {\n  0% {\n    transform: rotate(90deg);\n  }\n\n  to {\n    transform: rotate(0);\n  }\n}\n\n@keyframes rotation-rl {\n  0% {\n    transform: rotate(90deg);\n  }\n\n  to {\n    transform: rotate(0);\n  }\n}\n\n@-webkit-keyframes slide-in {\n  0% {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes slide-in {\n  0% {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@-webkit-keyframes slide-out {\n  0% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n\n  to {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n}\n\n@keyframes slide-out {\n  0% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n\n  to {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n}\n\n.rcw-widget-container {\n  bottom: 0;\n  display: flex;\n  flex-direction: column;\n  margin: 0 20px 20px 0;\n  position: relative !important;\n  right: 0;\n  z-index: 9999;\n  width: 100% !important;\n}\n\n.rcw-full-screen {\n  height: 100vh;\n  margin: 0;\n  max-width: none;\n  width: 100%;\n}\n\n@media screen and (max-width: 800px) {\n  .rcw-widget-container {\n    height: 100%;\n    height: 100vh;\n    margin: 0;\n    max-width: none;\n    width: 100%;\n  }\n}\n\n.rcw-previewer .rcw-message-img {\n  cursor: pointer;\n}\n\n.rcw-close-widget-container {\n  height: -webkit-max-content;\n  height: -moz-max-content;\n  height: max-content;\n  width: -webkit-max-content;\n  width: -moz-max-content;\n  width: max-content;\n}\n\n/********************Custome Chat**************************/\n/********************Custom Chat**************************/\n.chat-container {\n  display: flex;\n  flex-direction: column;\n  height: calc(100vh - 180px); /* adjust according to your header */\n}\n\n.messegeBox {\n  flex: 1;\n  overflow-y: auto;\n}\n\n.chatBottom {\n  flex-shrink: 0;\n  position: relative;\n}\n\n.editor-wrapper {\n  overflow: hidden;\n  max-height: 0;\n  opacity: 0;\n  transition:\n    max-height 0.35s ease,\n    opacity 0.25s ease;\n}\n\n.editor-wrapper.open {\n  max-height: 180px; /* editor height */\n  opacity: 1;\n}\n\n.msgheader {\n  height: 70px;\n}\n\n/* .messegeBox {\n  height: calc(100vh - 314px);\n  overflow-y: auto;\n} */\n\n/* .chatBottom {\n  height: 146px;\n} */\n\n.requestMsg {\n  text-align: left;\n  background: #7070701a;\n  color: #707070;\n  padding: 5px 15px;\n  border-radius: 10px 15px 0px 10px;\n  width: max-content;\n  max-width: 60%;\n  margin: auto;\n  margin-right: 0;\n  margin-bottom: 10px;\n  -webkit-border-radius: 10px 15px 0px 10px;\n  -moz-border-radius: 10px 15px 0px 10px;\n  -ms-border-radius: 10px 15px 0px 10px;\n  -o-border-radius: 10px 15px 0px 10px;\n}\n\n.responseMsg {\n  background: #016fe91a;\n  color: #707070;\n  padding: 5px 15px;\n  border-radius: 15px 10px 10px 0;\n  width: max-content;\n  max-width: 60%;\n  margin-bottom: 10px;\n  -webkit-border-radius: 15px 10px 10px 0;\n  -moz-border-radius: 15px 10px 10px 0;\n  -ms-border-radius: 15px 10px 10px 0;\n  -o-border-radius: 15px 10px 10px 0;\n}\n\n.chatBottom div {\n  width: 100%;\n  margin-bottom: 0 !important;\n}\n\n.chatBottom input[type=\"text\"] {\n  border-radius: 20px;\n  -webkit-border-radius: 20px;\n  -moz-border-radius: 20px;\n  -ms-border-radius: 20px;\n  -o-border-radius: 20px;\n  margin-bottom: 0;\n}\n\n.attachmentBox {\n  background-color: #e8eaf5;\n  /* width: 140px; */\n  width: max-content;\n  bottom: 33px;\n  right: 0;\n}\n\n.mediaicon {\n  border: 1px solid;\n  border-radius: 50%;\n  width: 35px;\n  height: 35px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 5px;\n  cursor: pointer;\n  margin: auto;\n}\n\n.mediaicon svg {\n  font-size: 1rem;\n}\n\n.chatimg {\n  width: 100px;\n}\n\n.contentBox .nav-btn-bgcolor {\n  background-color: var(--purple);\n  color: white;\n}\n\n/********************RTMP Live Video Chat**************************/\n.rtmp-chat .chat-main {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  overflow: hidden;\n}\n\n.rtmp-chat-header {\n  height: 56px;\n  background: #ffffff;\n  border-bottom: 1px solid #e5e7eb;\n  display: flex;\n  align-items: center;\n  padding: 0 20px;\n  gap: 16px;\n  flex-shrink: 0;\n  overflow: hidden;\n}\n\n.rtmp-chat-header .live-badge {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n  background: #fee2e2;\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #dc2626;\n  animation: pulse 2s infinite;\n}\n\n.rtmp-chat-header-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: #1f2937;\n  flex-shrink: 0;\n}\n\n.header-spacer {\n  flex: 1;\n  min-width: 16px;\n}\n\n/* Toggle group — three toggle pills in header */\n.toggle-group {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex-shrink: 0;\n}\n\n.toggle-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 12px;\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  white-space: nowrap;\n}\n\n.toggle-item.public {\n  background: #fffbeb;\n  border-bottom: 3px solid #fde68a;\n}\n\n.toggle-item-label {\n  font-size: 12px;\n  font-weight: 500;\n  color: #6b7280;\n  white-space: nowrap;\n  line-height: 1;\n}\n\n.toggle-item-label strong {\n  font-weight: 700;\n  color: #374151;\n}\n\n.toggle-item-label.on {\n  color: #1f2937;\n}\n\n.toggle-item.broadcast-active .toggle-item-label {\n  color: #7c3aed;\n}\n\n/* Toggle switch */\n.toggle-track {\n  width: 36px;\n  height: 20px;\n  border-radius: 10px;\n  position: relative;\n  transition: background 0.2s ease;\n  cursor: pointer;\n  flex-shrink: 0;\n  border: none;\n  padding: 0;\n  display: block;\n}\n\n.toggle-track.on {\n  background: #016fe9;\n}\n\n.toggle-track.off {\n  background: #d1d5db;\n}\n\n.toggle-track.broadcast-on {\n  background: #7c3aed;\n}\n\n.toggle-thumb {\n  width: 14px;\n  height: 14px;\n  border-radius: 50%;\n  background: #fff;\n  position: absolute;\n  top: 3px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n  transition: left 0.22s cubic-bezier(0.4, 0, 0.2, 1);\n  pointer-events: none;\n}\n\n.toggle-track.on .toggle-thumb,\n.toggle-track.broadcast-on .toggle-thumb {\n  left: 18px;\n}\n\n.toggle-track.off .toggle-thumb {\n  left: 3px;\n}\n\n/* Legacy visibility-pill hidden */\n.visibility-pill {\n  display: none;\n}\n\n.btn-participants {\n  display: none;\n  align-items: center;\n  gap: 6px;\n  background: #f3f4f6;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 6px 12px;\n  font-size: 13px;\n  color: #374151;\n  font-weight: 500;\n}\n\n.btn-participants.show {\n  display: flex;\n}\n\n.message-container {\n  flex: 1;\n  display: flex;\n  overflow: hidden;\n}\n\n/* --- Sidebar --- */\n.rtmp-sidebar {\n  width: 280px;\n  min-width: 280px;\n  background: #ffffff;\n  border-right: 1px solid #e5e7eb;\n  display: flex;\n  flex-direction: column;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  overflow: hidden;\n}\n\n.sidebar.closed {\n  width: 0;\n  min-width: 0;\n}\n\n.sidebar-header {\n  padding: 20px 16px 12px;\n  border-bottom: 1px solid #f3f4f6;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.sidebar-title {\n  font-size: 15px;\n  font-weight: 600;\n  color: #1f2937;\n}\n\n.sidebar-subtitle {\n  font-size: 12px;\n  color: #6b7280;\n  margin-top: 2px;\n}\n\n.sidebar-subtitle .count {\n  color: #059669;\n  font-weight: 600;\n}\n\n.btn-close-sidebar {\n  color: #9ca3af;\n  padding: 4px;\n  border-radius: 6px;\n  display: flex;\n}\n\n.btn-close-sidebar:hover {\n  color: #6b7280;\n}\n\n/* Search */\n.sidebar-search {\n  padding: 12px 12px 8px;\n}\n\n.search-box {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: #f9fafb;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 8px 12px;\n}\n\n.search-box input {\n  border: none;\n  background: transparent;\n  outline: none;\n  font-size: 13px;\n  color: #374151;\n  width: 100%;\n}\n\n.student-list {\n  flex: 1;\n  overflow-y: auto;\n  padding: 4px 8px;\n}\n\n.student-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px;\n  width: 100%;\n  border-radius: 8px;\n  text-align: left;\n  transition: background 0.15s;\n}\n\n.student-item:hover {\n  background: #f9fafb;\n}\n\n.student-item.selected {\n  background: #eff6ff;\n}\n\n.avatar {\n  width: 34px;\n  height: 34px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  font-weight: 600;\n  flex-shrink: 0;\n  background: linear-gradient(135deg, #e0e7ff, #c7d2fe);\n  color: #4338ca;\n}\n\n.avatar.active-avatar {\n  background: linear-gradient(135deg, #016fe9, #4f9cf7);\n  color: #ffffff;\n}\n\n.avatar.small {\n  width: 28px;\n  height: 28px;\n  font-size: 10px;\n  font-weight: 700;\n}\n\n.student-name {\n  font-size: 13px;\n  font-weight: 500;\n  color: #1f2937;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  flex: 1;\n  min-width: 0;\n}\n\n.status-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.status-dot.active {\n  background: #059669;\n}\n\n.status-dot.idle {\n  background: #d1d5db;\n}\n\n/* --- Chat Area --- */\n.chat-area {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  overflow: hidden;\n}\n\n/* Warning banner */\n.warning-banner {\n  background: #fffbeb;\n  border-bottom: 1px solid #fde68a;\n  padding: 8px 16px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 12.5px;\n  color: #92400e;\n  font-weight: 500;\n  animation: fadeUp 0.25s ease;\n}\n\n.warning-banner.hidden-state {\n  display: none;\n}\n\n/* Messages container */\n.messages {\n  flex: 1;\n  overflow-y: auto;\n  padding: 16px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  max-height: calc(100vh - 56px - 140px);\n}\n\n/* Message row */\n.msg-row {\n  display: flex;\n  padding: 3px 0;\n}\n\n.msg-row.admin {\n  justify-content: flex-end;\n}\n\n.msg-row.student {\n  justify-content: flex-start;\n}\n\n.msg-col {\n  max-width: 70%;\n  display: flex;\n  flex-direction: column;\n}\n\n.msg-row.admin .msg-col {\n  align-items: flex-end;\n}\n\n.msg-row.student .msg-col {\n  align-items: flex-start;\n}\n\n.msg-sender {\n  font-size: 11px;\n  font-weight: 600;\n  color: #6b7280;\n  margin-bottom: 3px;\n  padding-left: 4px;\n}\n\n.msg-inner {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.msg-row.admin .msg-inner {\n  flex-direction: row-reverse;\n}\n\n.msg-bubble {\n  padding: 12px 14px;\n  font-size: 13.5px;\n  line-height: 1.5;\n}\n\n.msg-row.student .msg-bubble {\n  background: #f3f4f6;\n  color: #1f2937;\n  border-radius: 16px 16px 16px 4px;\n}\n\n.msg-row.admin .msg-bubble {\n  background: #016fe9;\n  color: #fff;\n  border-radius: 16px 16px 4px 16px;\n}\n\n/* Visibility tag under admin msgs */\n.msg-visibility {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin-top: 4px;\n  font-size: 11px;\n}\n\n.msg-visibility.vis {\n  color: #059669;\n}\n\n.msg-visibility.hid {\n  color: #9ca3af;\n}\n\n.msg-time {\n  font-size: 10px;\n  color: #9ca3af;\n  margin-top: 2px;\n}\n\n/* Hover actions on student messages */\n.msg-actions {\n  display: none;\n  gap: 2px;\n  position: relative;\n}\n\n.msg-row.student:hover .msg-actions {\n  display: flex;\n}\n\n.btn-msg-action {\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  width: 28px;\n  height: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #9ca3af;\n  transition: all 0.15s;\n}\n\n.btn-msg-action:hover {\n  border-color: #016fe9;\n  color: #016fe9;\n}\n\n/* Action dropdown */\n.action-dropdown {\n  position: absolute;\n  left: 32px;\n  top: 0;\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  z-index: 10;\n  overflow: hidden;\n  min-width: 140;\n  display: none;\n}\n\n.action-dropdown.open {\n  display: block;\n}\n\n.action-dropdown button {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 14px;\n  width: 100%;\n  font-size: 12.5px;\n}\n\n.action-dropdown .delete-btn {\n  color: #dc2626;\n}\n\n.action-dropdown .delete-btn:hover {\n  background: #fef2f2;\n}\n\n.action-dropdown .mute-btn {\n  color: #d97706;\n}\n\n.action-dropdown .mute-btn:hover {\n  background: #fffbeb;\n}\n\n/* New messages pill */\n.new-msg-pill {\n  position: absolute;\n  bottom: 80px;\n  left: 50%;\n  transform: translateX(-50%);\n  background: #016fe9;\n  color: #fff;\n  border-radius: 20px;\n  padding: 6px 160px;\n  font-size: 12px;\n  font-weight: 500;\n  box-shadow: 0 4px 12px rgba(1, 111, 233, 0.25);\n  display: none;\n  align-items: center;\n  gap: 4px;\n  z-index: 5;\n  animation: fadeUp 0.2s ease;\n}\n\n.new-msg-pill.show {\n  display: flex;\n}\n\n/* --- Compose Area --- */\n.compose-area {\n  border-top: 1px solid #e5e7eb;\n  background: #ffffff;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n/* Message input box */\n.compose-input-area {\n  padding: 12px 20px 16px;\n  display: block;\n}\n\n.compose-visibility {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: 12px;\n  font-size: 14px;\n  font-weight: 500;\n  padding: 6px 14px;\n  border-radius: 6px;\n}\n\n.compose-visibility.vis {\n  color: #059669;\n  background: #f0fdf4;\n  border: 1px solid #bbf7d0;\n}\n\n.compose-visibility.hid {\n  color: #d97706;\n  background: #fffbeb;\n  border: 1px solid #fde68a;\n}\n\n.compose-row {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n.compose-row .message {\n  flex: 1;\n  padding: 30px;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  font-size: 14px;\n  outline: none;\n  line-height: 1.5;\n  max-height: 120px;\n  color: #1f2937;\n  background: #f9fafb;\n  transition:\n    border 0.15s,\n    background 0.15s;\n}\n\n.compose-row .message:focus {\n  border-color: #016fe9;\n  background: #ffffff;\n}\n\n.compose-input-area .btn-send {\n  height: 48px;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 0 16px;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.15s;\n  flex-shrink: 0;\n}\n\n.compose-input-area .btn-send.active {\n  background: #016fe9;\n  color: #fff;\n  box-shadow: 0 2px 8px rgba(1, 111, 233, 0.25);\n}\n\n.compose-input-area .btn-send.active:hover {\n  background: #0157b8;\n  box-shadow: 0 4px 12px rgba(1, 111, 233, 0.25);\n}\n\n.compose-input-area .btn-send.disabled {\n  background: #e5e7eb;\n  color: #9ca3af;\n  cursor: not-allowed;\n}\n\n/* Toast */\n.toast {\n  position: fixed;\n  top: 20px;\n  right: 20px;\n  z-index: 9999;\n  color: #fff;\n  padding: 12px 16px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  display: none;\n  align-items: center;\n  gap: 12px;\n  max-width: 340px;\n  animation: toastIn 0.3s ease;\n}\n\n.toast.show {\n  display: flex;\n}\n\n.toast.success {\n  background: #059669;\n}\n\n.toast.warning {\n  background: #d97706;\n}\n\n/* ════ RESPONSIVE ════ */\n@media (max-width: 768px) {\n  .sidebar {\n    position: fixed;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    z-index: 100;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  }\n\n  .sidebar.closed {\n    width: 0;\n    min-width: 0;\n  }\n\n  .btn-participants {\n    display: flex;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
